<div class="simulatorForm">
  <form [formGroup]="form" (ngSubmit)="onContinue()" class="form">
    <div class="simulator__container">
      <div class="simulator pb-17">
        <div class="simulator__block simulator__block--amount mb-25">
          <div class="simulator__label">
            <span>¿Cúanto dinero necesitas?</span>
          </div>

          <div class="simulator__amount">
            <div class="amount">
              <div class="amount__btn">
                <p-button icon="pi pi-minus" class="p-button-secondary p-button-raised p-button-rounded" [disabled]="!canDecrease()" (onClick)="decreaseAmount()"></p-button>
              </div>

              <div class="amount__value"><span><small>{{country.currency}} </small>{{selectedPrice | number:'1.0-0'}}</span></div>

              <div class="amount__btn">
                <p-button icon="pi pi-plus" class="p-button-secondary p-button-raised p-button-rounded" [disabled]="!canIncrease()" (onClick)="increaseAmount()"></p-button>
              </div>
            </div>
          </div>
        </div>

        <div class="simulator__block simulator__block--paymentTerm">
          <div class="simulator__label">
            <span>¿A qué plazo puedes pagarlo?</span>
          </div>

          <div class="simulator__paymentTerm">
            <div class="paymentTerm">
              <div class="paymentTerm__value">
                <span>{{selectedQuotas}} cuotas quincenales</span>
              </div>

              <div class="paymentTerm__slider">
                <div class="range__slider">
                  <p-slider [ngModel]="selectedQuotas" [step]="4" [min]="minDay() / 15" [max]="maxDay() / 15" (onSlideEnd)="onQuotaSliderChange($event.value)" [ngModelOptions]="{standalone: true}"></p-slider>
                </div>

                <div class="range__references">
                  <span>{{minDay() / 15}} cuotas</span>
                  <span>{{maxDay() / 15}} cuotas</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="simulator__result" *ngIf="simulationsResults() && simulationsResults().quota_from">
        <div class="result__block">
          <div class="result__title">
            <h2>Detalle</h2>
          </div>

          <div class="result__content">
            <div class="result__item">
              <div class="result__name">
                <span>Monto solicitado</span>
              </div>

              <div class="result__value">
                <span>{{selectedPrice | currency: country.currency:'symbol':'1.0-0'}}</span>
              </div>
            </div>

            <div class="result__item">
              <div class="result__name">
                <span>Cuota quincenal</span>
              </div>

              <div class="result__value">
                <span>{{simulationsResults().quota_from | currency: country.currency:'symbol':'1.0-0'}}</span>
              </div>
            </div>

            <div class="result__item">
              <div class="result__name">
                <span>Total cuotas</span>
              </div>

              <div class="result__value">
                <span>{{selectedQuotas}} cuotas quincenales</span>
              </div>
            </div>

            <div class="result__item">
              <div class="result__name">
                <span>Próximo pago</span>
              </div>

              <div class="result__value">
                <span>{{simulationsResults().first_payment_date | date: 'd \'de\' MMMM yyyy'}}</span>
              </div>
            </div>

            <div class="result__item result__item--total">
              <div class="result__name">
                <span>Total a pagar</span>
              </div>

              <div class="result__value">
                <span>{{(simulationsResults().quota_from * selectedQuotas) | currency: country.currency:'symbol':'1.0-0'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="result__terms">
          <p>* Sujeto a politicas de aprobación</p>
        </div>
      </div>
    </div>

    <div class="simulator__btn pt-25">
      <button pButton pRipple type="submit" [label]="simulationsResults() && simulationsResults().quota_from ? 'Continuar' : 'Simular'" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded p-button-spaced w-full"></button>
    </div>
  </form>
</div>
